module.exports = __webpack_public_path__ + "img/cbf.8c320e5.png";